import { render, staticRenderFns } from "./MenusDashboard.vue?vue&type=template&id=5834e127&scoped=true&"
import script from "./MenusDashboard.vue?vue&type=script&lang=js&"
export * from "./MenusDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MenusDashboard.vue?vue&type=style&index=0&id=5834e127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834e127",
  null
  
)

export default component.exports